export const personalInfoToGraphQL = formValues => ({
  email: formValues.email,
  name: formValues.name,
  phone: formValues.phoneNumber
});

export const ownerNameToGraphQL = ({
  customOwnerName,
  predefinedOwnerName
}) => ({
  owner_name: customOwnerName || predefinedOwnerName
});
